<template>
	<div class="fi-row">
		<span class="fi-rowIcon"><sym-icon name="comment"></sym-icon></span>
		<div class="fi-row-message">
			<span v-if="comment.html" v-html="comment.content"></span>
			<span v-else>{{ comment.content }}</span>
			<span style="display:flex;gap:4px"><it-link :to="'editComment.do?id='+comment.id" class="fi-edit-icon"><sym-icon name="edit"></sym-icon></it-link>
			<fi-date v-if="comment.modified || comment.entered" :value="comment.modified || comment.entered"></fi-date></span>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import {SrcType} from "@t/meta/SourceType.ts";
import ObjectLink from "@fd/helpers/ObjectLink.vue";
import FiDate from "@/processes/FiDate.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import ItLink from "@/router/ItLink.vue";
import {Comment} from "@t/note/Comment.ts";

const props = defineProps<{
	comment: Comment
}>();
</script>

<style>
.fi-edit-icon {
	cursor: pointer;
	opacity: 0.5;
	&:hover {
		opacity: 1;
	}
}
</style>